import { createContext, h } from 'preact';
import { useContext } from 'preact/hooks';

const WriteGate = createContext(() => true);
// Keep children mounted while reads revalidate. Check live state at dispatch,
// too: a timer can mark a resource stale before Preact renders disabled buttons.
export function WriteBoundary({ resources = [], children }) {
  const parent = useContext(WriteGate);
  return h(WriteGate.Provider, { value: () => parent() && resources.every((r) =>
    r.canWrite ? r.canWrite() : r.status === 'ready' && !r.isStale) }, children);
}
export const useWriteGate = () => useContext(WriteGate);
